"use client";

import { useTranslations } from "next-intl";

function CheckBullet() {
	return (
		<div
			className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#76a734]"
			aria-hidden
		>
			<svg className="h-3.5 w-3.5 text-white" viewBox="0 0 12 10" fill="none" aria-hidden>
				<path
					d="M1 5l3.5 3.5L11 1"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
}

const WHEN_ITEM_KEYS = [
	{ titleKey: "when1_title", descKey: "when1_desc" },
	{ titleKey: "when2_title", descKey: "when2_desc" },
	{ titleKey: "when3_title", descKey: "when3_desc" },
	{ titleKey: "when4_title", descKey: "when4_desc" },
] as const;

const TABLE_ROWS = [
	{
		criteriaKey: "row1_criteria",
		injectionKey: "row1_injection",
		cncKey: "row1_cnc",
		printingKey: "row1_printing",
	},
	{
		criteriaKey: "row2_criteria",
		injectionKey: "row2_injection",
		cncKey: "row2_cnc",
		printingKey: "row2_printing",
	},
	{
		criteriaKey: "row3_criteria",
		injectionKey: "row3_injection",
		cncKey: "row3_cnc",
		printingKey: "row3_printing",
	},
	{
		criteriaKey: "row4_criteria",
		injectionKey: "row4_injection",
		cncKey: "row4_cnc",
		printingKey: "row4_printing",
	},
	{
		criteriaKey: "row5_criteria",
		injectionKey: "row5_injection",
		cncKey: "row5_cnc",
		printingKey: "row5_printing",
	},
] as const;

/**
 * 何时选注塑（左列表）+ 与 CNC / 3D 打印对比表（右）
 */
export default function PlasticInjectionMoldingWhenVsCompare() {
	const t = useTranslations("plasticInjectionMoldingWhenVsCompare");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 gap-12 text-left lg:grid-cols-5 lg:gap-8 xl:gap-10">
					{/* 左：何时选择（约 2/5） */}
					<div className="min-w-0 lg:col-span-2">
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("whenToChooseTitle")}
						</h2>
						<p className="mb-8 text-base font-bold text-black sm:mb-10 sm:text-lg">
							{t("whenToChooseSubtitle")}
						</p>
						<ul className="flex flex-col gap-5 sm:gap-6">
							{WHEN_ITEM_KEYS.map((keys) => (
								<li key={keys.titleKey} className="flex gap-3 sm:gap-4">
									<CheckBullet />
									<p className="min-w-0 text-sm !leading-relaxed text-black sm:text-base">
										<span className="font-bold">{t(keys.titleKey)}:</span> {t(keys.descKey)}
									</p>
								</li>
							))}
						</ul>
					</div>

					{/* 右：对比表（约 3/5） */}
					<div className="min-w-0 lg:col-span-3">
						<h3 className="mb-6 text-lg font-bold text-[#76a734] sm:text-xl md:text-2xl">
							{t("compareTitle")}
						</h3>
						<div className="overflow-x-auto [-webkit-overflow-scrolling:touch]">
							<table className="w-full min-w-[520px] border-collapse border border-gray-200 text-sm sm:text-sm">
								<thead>
									<tr className="bg-[#76a734] text-white">
										<th className="border border-gray-200 px-3 py-3 text-left font-bold sm:px-4 sm:py-3.5">
											{t("th_criteria")}
										</th>
										<th className="border border-gray-200 px-3 py-3 text-center font-bold sm:px-4 sm:py-3.5">
											{t("th_injection")}
										</th>
										<th className="border border-gray-200 px-3 py-3 text-center font-bold sm:px-4 sm:py-3.5">
											{t("th_cnc")}
										</th>
										<th className="border border-gray-200 px-3 py-3 text-center font-bold sm:px-4 sm:py-3.5">
											{t("th_printing")}
										</th>
									</tr>
								</thead>
								<tbody className="bg-white text-black">
									{TABLE_ROWS.map((row) => (
										<tr key={row.criteriaKey}>
											<td className="border border-gray-200 px-3 py-3 align-top font-medium sm:px-4 sm:py-3.5">
												{t(row.criteriaKey)}
											</td>
											<td className="border border-gray-200 px-3 py-3 text-center align-top sm:px-4 sm:py-3.5">
												{t(row.injectionKey)}
											</td>
											<td className="border border-gray-200 px-3 py-3 text-center align-top sm:px-4 sm:py-3.5">
												{t(row.cncKey)}
											</td>
											<td className="border border-gray-200 px-3 py-3 text-center align-top sm:px-4 sm:py-3.5">
												{t(row.printingKey)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
